@if (!(loading$ | async)) {
    <mat-dialog-content>
        <div class="flex flex-row justify-end gap-2 mb-2">
            <mat-checkbox [checked]="!!formGroup.get('boxPacking').value" (change)="setBoxPacking($event.checked)">Enable for Box Packing</mat-checkbox>
            <button mat-button [matMenuTriggerFor]="packagingTypeMenu">{{ packagingTypeDisplay$ | async }}</button>
            <mat-menu #packagingTypeMenu>
                @for (pt of packagingTypes$ | async; track pt) {
                    <button mat-menu-item (click)="setPackagingType(pt.code)">{{ pt.name }}</button>
                }
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="currencyMenu">{{ currency$ | async }}</button>
            <mat-menu #currencyMenu>
                @for (currency of currencies$ | async; track currency) {
                    <button mat-menu-item (click)="setCurrency(currency)">{{ currency }}</button>
                }
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="weightUnitMenu">{{ weightUnitDisplay$ | async }}</button>
            <mat-menu #weightUnitMenu>
                <button mat-menu-item (click)="setWeightUnit(KG)" i18n>KG/CM</button>
                <button mat-menu-item (click)="setWeightUnit(LB)" i18n>Pounds/Inches</button>
            </mat-menu>
        </div>
        <app-package-form
                [formGroup]="formGroup"
                [currency]="currency$ | async"
                [weightUnit]="weightUnit$ | async"
                [dimensionUnit]="dimensionUnit$ | async">
        </app-package-form>
    </mat-dialog-content>
    <mat-dialog-actions class="flex">
        <button mat-button (click)="addCommodity()" i18n>Add Commodity</button>
        <button mat-button (click)="deleteCommodity()" [disabled]="formCommodities().length === 0" i18n>Delete
            Commodity
        </button>
        <span class="flex-grow"></span>
        <button matButton (click)="close()" i18n>Close</button>
        @if (!(saving$ | async)) {
            <button matButton="filled" color="primary" (click)="submit()" [disabled]="disableSave$ | async">Save
            </button>
        }
        @if (saving$ | async) {
            <button matButton="filled" color="primary" [disabled]="true" i18n>
                Saving...
                <app-icon icon="spinner" [spin]="true"></app-icon>
            </button>
        }
    </mat-dialog-actions>
}


@if (loading$ | async) {
    <div class="flex flex-col gap-4 m-16 justify-center items-center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
}